/**
 * Commerce client factory
 * Simple client creation and management
 */

import { CommerceClient } from "./interface";
import { ShopifyCommerceClient } from "../adapters/shopify";
import { IShopifyConfig } from "../adapters/shopify/interface";
import { ICustomConfig } from "../adapters/custom/interface";
import { CustomBackendClient } from "../adapters/custom/service";

/**
 * Create a Shopify commerce client
 * @param config Shopify configuration
 * @returns ShopifyCommerceClient instance
 */
export function createShopifyClient(
  config: IShopifyConfig
): ShopifyCommerceClient {
  return new ShopifyCommerceClient(config);
}

/**
 * Create a Custom Backend commerce client
 * @param config Custom backend configuration
 * @returns CustomBackendClient instance
 */
export function createCustomClient(config: ICustomConfig): CustomBackendClient {
  return new CustomBackendClient(config);
}

/**
 * Commerce client configuration options
 */
export type IClientConfig =
  | { type: "shopify"; config: IShopifyConfig }
  | { type: "custom"; config: ICustomConfig };

/**
 * Create a commerce client based on configuration
 * @param clientConfig Client configuration with type and config
 * @returns CommerceClient instance
 */
export function createCommerceClient(
  clientConfig: IClientConfig
): CommerceClient {
  switch (clientConfig.type) {
    case "shopify":
      return createShopifyClient(clientConfig.config);
    case "custom":
      return createCustomClient(clientConfig.config);
    default:
      throw new Error(`Unsupported client type: ${(clientConfig as any).type}`);
  }
}
